import QueryString from "qs";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { IStaticPage } from "../Interfaces/IStaticPage";
import { VideoPage } from "../Interfaces/IVideoPage";
import { getPageContent } from "../Services/UmbracoService";
import { VideoPagesIndex } from "../Utils/consts";
import StaticPage from "./StaticPage";

const Main: React.FC = () => {
  const location = useLocation();
  const [_staticPageContent, _setStaticPageContent] = useState<IStaticPage>({
    coverImage: { _url: "" },
    elements: [
      {
        header: "",
        previewImage: { _url: "" },
        subHeader: "",
        video: { _url: "" },
      },
    ],
    pageHeader: "",
    elementIndex: 0,
  });
  const [_showPage, _setShowPage] = useState<string>("");
  const [_showIndex, _setShowIndex] = useState<number>(0);

  useEffect(() => {
    const urlParams = QueryString.parse(location.search.split("?")[1]);

    (async () => {
      const content = (await getPageContent()) as IStaticPage;
      _setStaticPageContent(content);
      if (urlParams.page?.length) {
        const page = urlParams.page
          .toString()
          .toLocaleLowerCase() as VideoPage["name"];
        _setShowPage(page);
        _setShowIndex(VideoPagesIndex[`${page}`]);
      } else {
      }
    })();
    console.log("params", location.search.split("?")[1]);
  }, [location]);

  return (
    <div>
      {_showPage != "" ? (
        <StaticPage {..._staticPageContent} elementIndex={_showIndex} />
      ) : null}
    </div>
  );
};

export default Main;
